import React from 'react'

const DownArrow: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="14"
      width="14"
      viewBox="0 0 1024 1024"
      fill="#000000"
      {...props}
    >
      <path d="M903.232 256l56.768 50.432L512 768 64 306.432 120.768 256 512 659.072z" />
    </svg>
  )
}

export default DownArrow
